import { useEffect, useState } from "react";

interface LoadingEllipsisProps {
  text: string;
}

const LoadingEllipsis: React.FC<LoadingEllipsisProps> = ({ text }) => {
  const [dots, setDots] = useState<number>(1);

  useEffect(() => {
    const id = setInterval(() => {
      setDots((prev) => (prev === 3 ? 1 : prev + 1));
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <span>
      {text}
      {'.'.repeat(dots)}
    </span>
  );
};

export default LoadingEllipsis;